import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GridModalComponent } from '@app/core/components/grid/grid.decorators';
import { GridRow } from '@app/core/components/grid/grid.types';
import { GridModalData } from '@app/core/components/grid/modals/grid-modal.service';
import { ModalService } from '@app/core/services/modal.service';
import { ComponentGet, ComponentService } from '@app/services/component.service';
import { ProductService, ProductUnitItem } from '@app/services/product.service';

@GridModalComponent('ComponentCalculationGridModalTs')
@Component({
    selector: 'tt-component-calculation-grid-modal',
    templateUrl: './component-calculation-grid-modal.component.html',
    styleUrls: ['./component-calculation-grid-modal.component.css'],
    standalone: false,
})
export class ComponentCalculationGridModalComponent {
    public get?: ComponentGet;

    public productUnits: ProductUnitItem[] = [];

    public loading = false;

    public saving = false;

    private gridRow?: GridRow;

    public get heading() {
        return this.get?.sublabel_helpcalc || 'component_calculation';
    }

    constructor(
        public dialogRef: MatDialogRef<ComponentCalculationGridModalComponent>,
        @Inject(MAT_DIALOG_DATA) private data: GridModalData,
        private modal: ModalService,
        private component: ComponentService,
        private product: ProductService,
    ) {
        this.gridRow = data.row ?? data.selectedRows?.[0];
        this.dialogRef.updateSize('min(40rem, 95vw)');
        void this.init();
    }

    public async save() {
        if (!this.get) return;

        try {
            this.saving = true;

            const response = await this.component.saveComponent(this.get);

            if ('' + response?.errorcode !== '0') {
                this.modal.show({ type: 'warning', title: 'error', translateTitle: true, message: response.errormessage });
                return;
            }

            this.get.comp_keyno = response?.comp_keyno ?? this.get.comp_keyno;
        } finally {
            this.saving = false;
        }

        this.dialogRef.close(this.updateGridRowFromGet());
    }

    public cancel() {
        this.dialogRef.close();
    }

    private async loadProductUnits() {
        if (!!this.get && this.get.comp_is_prod_id > '') {
            this.productUnits = await this.product.getProductUnits({ prod_id: this.get.comp_is_prod_id });
        }
    }

    private async loadGet() {
        const parameters = await this.getLoadDataParameters();
        const compKeyno = this.toString(this.gridRow?.['comp_keyno']);
        const prodKeyno = this.toString(parameters['prod_keyno']) || this.toString(parameters['prod_id']);

        if (!!compKeyno && !!prodKeyno) {
            this.get = await this.component.getComponent({ prod_id: prodKeyno, comp_keyno: compKeyno });
        }
    }

    private async getLoadDataParameters(): Promise<Record<string, unknown>> {
        const parameters = this.data.loadData?.parameters as unknown;

        if (typeof parameters === 'function') {
            return ((await parameters()) ?? {}) as Record<string, unknown>;
        }

        return !!parameters && typeof parameters === 'object' ? (parameters as Record<string, unknown>) : {};
    }

    private async init() {
        try {
            this.loading = true;
            await this.loadGet();
            await this.loadProductUnits();
        } finally {
            this.loading = false;
        }
    }

    private toString(value: unknown): string {
        return value === undefined || value === null ? '' : '' + value;
    }

    private updateGridRowFromGet() {
        if (!this.get || !this.gridRow) return this.get;

        Object.keys(this.gridRow).forEach((key) => {
            if (key in this.get!) {
                this.gridRow![key] = this.get![key as keyof ComponentGet];
            }
        });

        return this.gridRow;
    }
}
